import { useMutation } from '@tanstack/react-query'
import { createWorkShiftCustomField } from 'api/company'
import { useAuthContext } from 'components/auth'
import { MutationOptions } from 'queries/types'
import { useInvalidateWorkShiftCustomFields } from './useWorkShiftCustomFields'

type CreateWorkShiftCustomFieldVariables = {
  key: string
}

export function useCreateWorkShiftCustomFieldMutation(
  options: MutationOptions<
    typeof createWorkShiftCustomField,
    unknown[],
    CreateWorkShiftCustomFieldVariables
  > = {}
) {
  const { company } = useAuthContext()
  const { invalidate } = useInvalidateWorkShiftCustomFields()

  return useMutation({
    ...options,
    mutationFn: async ({ key }: CreateWorkShiftCustomFieldVariables) => {
      if (!company?.id) {
        throw new Error('Company id not found')
      }
      return createWorkShiftCustomField(company.id, { key })
    },
    onSuccess: async (...args) => {
      await invalidate()
      await options.onSuccess?.(...args)
    },
  })
}
